<template>
  <f7-page name="info" class="navbar-through toolbar-fixed">
    <f7-navbar>
      <f7-nav-left><div class="navbar-left-space"></div></f7-nav-left>
      <f7-nav-title class="navbar-center-title">{{ pro.name }}</f7-nav-title>
      <f7-nav-right>
        <f7-button @click="$f7router.navigate('/')"><f7-icon f7="home_fill"></f7-icon></f7-button>
      </f7-nav-right>
    </f7-navbar>

    <f7-block-title>
      <h2 class="pro-subtitle" v-html="pro.subtitle"></h2>
    </f7-block-title>

    <f7-block>
      <div class="pro-description" v-html="pro.description"></div>
    </f7-block>

    <f7-block strong id="results-print">
      <f7-button fill raised @click="$f7router.navigate(`/pro/${pro.id}/`)">Naprej</f7-button>
    </f7-block>
  </f7-page>
</template>

<script>
import {getPro} from '../assets/pros/pros'

export default {
  name: 'Info',
  data () {
    return {
      pro: getPro(this.$f7route.params.id)
    }
  }
}
</script>

<style lang="scss" scoped>

  div[data-name="info"] /deep/ {

    .pro-description {
      text-align: justify;
    }

    .pro-subtitle {
      white-space: initial;
      line-height: 24px;
    }

    .navbar-left-space {
      display: inline-block;
      width: 48px;
      padding: 0 8px;
    }

    .navbar-center-title {
      display: flex;
      flex-grow: 100;
      justify-content: center;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/Info.vue